import {apiFormat} from '../timeFunctions/timeFns'

// users
export function urlCurrentUser() {
    return ("/auth/user");
}
export function urlVerifyCode (username, code) {
    return encodeURI('/tehama/site-list-server/user/support/verifycode?username='+username+'&code='
        +encodeURIComponent(code))
}
export function urlResendCode (username) {
    return encodeURI('/tehama/site-list-server/user/support/resendcode?username='+username)
}
export function urlSiteListUser (name=undefined) {
    const urlParam = name ? "?username="+encodeURIComponent(name) : ""
    return "/tehama/site-list-server/user"+urlParam
}
export function urlUpdateEmail(username, email) {
    return ("/tehama/site-list-server/user/support/update-email?username="
        +encodeURIComponent(username)+'&email-address='+encodeURIComponent(email))
}
export function urlUpdateRole () {
    return "/tehama/site-list-server/user/support/update-user-type"
}
// assets
export function urlPublicAssets(publicCustomer) {
    return urlCustomerAssets(publicCustomer)
}
export function urlCustomerAssets(customerId) {
    return '/customer/'+customerId+'/assets?type=DCAP&pageSize=1000&page=0';
}
export function urlAssignAssetToCustomer(assetId, customerId) {
    return "/tehama/customer/"+customerId+"/asset/"+assetId;
}
export function urlAssignAssetToPublic(assetId) {
    return '/tehama/customer/public/asset/'+assetId;
}
//sites
export function urlGetSite(accessCode) {
    return '/tehama/sites/'+accessCode;
}
export function urlGetCustomerSites(customerId) {
    return '/tehama/sites/customer/'+customerId;
}
export function urlGetReport(accessCode) {
    return '/tehama/sites/report-data/'+accessCode;
}
export function urlSiteDevices(siteId, type=null) {
    const param = type === null ? "" : "?ac_type="+type;
    return '/tehama/sites/'+siteId+'/devices'+param;
}
export function urlSiteDeviceConfig(siteId, deviceId=undefined) {
    const opt = deviceId ? '?device_ids='+deviceId : ''
    return '/tehama/sites/'+siteId+'/devices/configuration-data'+opt
}
export function urlReleaseSite(siteId) {
    return '/tehama/site-list-server/'+siteId+'/release'
}
export function urlClaimSite(siteId) {
    return '/tehama/site-list-server/'+siteId+'/claim'
}
export function urlServerbyNode (nodeId) {
    return '/tehama/site-list-server?node_id='+nodeId
}
export function urlSwapDcap(newac, oldac) {
    return '/tehama/sites/swap?new_ac='+newac+"&old_ac="+oldac
}
export function urlSiteDC(ac) {
    return '/tehama/disconnect?access_code='+ac
}
// devices
export function urlDeviceInfo(deviceId, accessCode) {
    return '/tehama/sites/devices/'+deviceId+'?access_code='+accessCode;
}
export function urlAddDevice(accessCode, deviceId) {
    return '/tehama/sites/'+accessCode+'/devices?device_id='+deviceId
}
export function urlSensorInfo(deviceId, accessCode, sensor) {
    return '/tehama/sites/devices/'+deviceId+'/sensors/'+sensor+'?access_code='+accessCode
}
export function urlDecommission (deviceId, accessCode) {
    return '/tehama/sites/devices/'+deviceId+'/target-ac?access_code='+accessCode
}
export function urlFactoryConfig(deviceId) {
    return '/dcap-email-log/device-factory-configuration?device_id='+deviceId
}
export function urlSiteFactoryCfg(ac) {
    return '/dcap-email-log/device-factory-configuration?access_code='+ac
}
// readings
export function urlSiteReadings (siteId, from, until, limit=4000, type='SensorData') {
    return '/tehama/sites/'+siteId+'/historical-data?' + 
    'start_ts='+from+'&end_ts='+until+'&limit='+limit+'&data_type='+type
}
export function urlSiteEntryIds (siteId, from, until, type='SensorData') {
    return '/tehama/sites/'+siteId+'/historical-data/entryids?data_type='+type +
        '&start_ts='+from+'&end_ts='+until
}
export function urlSiteReadingsById(siteId, startId, endId, type='SensorData') {
    return '/tehama/sites/'+siteId+'/historical-data/by-entryids?start_id='+startId + 
        '&end_id='+endId+'&data_type='+type
}
export function urlDeviceReadings (siteId, device, from, until, limit=5000, type='SensorData') {
    return '/tehama/sites/devices/'+device+'/historical-data?' + 
      'start_ts='+from+'&end_ts='+until+'&limit='+limit+'&data_type='+type+'&access_code='+siteId;
}
export function urlNonAdvancing (siteId, from, to) {
    return '/tehama/sites/'+siteId+'/non-incrementing?end_time='+to+"&start_time="+from
}
// grants
export function urlGrant() {
    return '/tehama/grant-support/current';
}
export function urlRequest() {
  return '/tehama/grant-support/request'
}
export function urlDeleteGrantRequest (entryId) {
    return '/tehama/grant-support/request?entryId='+entryId
}
export function urlPermission(siteId) {
  return "/tehama/connect?access_code="+siteId
}
// alerts
export function urlGetAlerts (siteId) {
  return '/tehama/sites/'+siteId+'/alerts-quick-set'
}
export function urlAlarmHistory(siteId) {
  return '/tehama/sites/'+siteId+'/alerts'
}
// scripts
export function urlGetScripts (siteId) {
  return '/drsupport/script-list?access_code='+siteId
}
export function urldrSupport () {
  return '/drsupport'
}
export function historicalReport(siteId, start, stop) {
    const from = apiFormat(start)
    const until = apiFormat(stop)
    return '/drsupport/historical?access_code='+siteId+'&start_datetime='+from+
        '&end_datetime='+until
}
export function userOptions() {
    return '/options?platform=WEB'
}
// kore - cellular dcaps
export function urlGetKoreStatus(accessCode, infoType='CELL_PRESENT') {
    return '/support/kore/status?info_type='+infoType+"&access_code="+accessCode;
}
// stripe
export function urlGetActiveSubscriptionStatus(accessCode) {
    return '/support/stripe/entries/active-subscriptions?access_code='+accessCode;
}
export function urlGetStripeSession(accessCode){
    return '/support/stripe/session?session_type=check_out&access_code='+accessCode;
}
export function urlGetUserStripeSubscriptions(){
    return '/support/stripe/customer/info?data_type=subscriptions';
}
export function urlGetUserStripeInvoicesForAccessCode(accessCode){
    return '/support/stripe/customer/info?data_type=invoices&access_code='+accessCode;
}
export function urlGetStripeSessionForPaymentUpdate(accessCode){
    return '/support/stripe/session?session_type=payment_method_update&access_code='+accessCode;
}
export function urlGetStripeCancelSubscriptionSession(accessCode) {
    return '/support/stripe/session?session_type=subscription_cancel&access_code='+accessCode;
}
export function urlGetStripeSessionForPay(accessCode){
    return '/support/stripe/session?session_type=view_account&access_code='+accessCode;
}
// ai
export function urlTehamaAgent () {
    return '/support/ai'
}
export function urlTehamaStatus () {
    return '/support/ai/status'
}